import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ao6jzfe6us: FaireBrandEntity = {
  token: "b_ao6jzfe6us",
  type: "brand",
  name: "HiBAR",
  avatarUrl:
    "https://cdn.faire.com/fastly/89374d6a162a8cc79f16af88eed985182960e8d7fa02c9dd3d008a0414ca4eea.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/6aa93c122c0e31d35eac7cf229ed0f05f104c84c0ea2350e7c4a7e3af9f1dbc8.png",
  logoUrl:
    "https://cdn.faire.com/fastly/89374d6a162a8cc79f16af88eed985182960e8d7fa02c9dd3d008a0414ca4eea.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/6aa93c122c0e31d35eac7cf229ed0f05f104c84c0ea2350e7c4a7e3af9f1dbc8.png",
  location: "St Paul, MN, USA",
  minimumOrderDollars: 125,
  rating: 4.9,
  reviewCount: 31,
  isTopShop: true,
  isInsider: true,
  description:
    "It all started with a simple, shared thought: plastic really, truly sucks.\n\nAfter seeing a beach littered with plastic, our founders knew something had to change—not someday, but now. And one of the biggest challenges? Hair care. Why was there no salon-quality, plastic-free option on the shelf?\n\nSo they set out to fix it.\n\nThree years of formulating later, HiBAR was born: salon-performance hair care and skin care that delivers incredible results and looks beautiful on display—no plastic bottles required. From our bestselling shampoo and conditioner bars to the world’s first solid cleansing oil bar, every HiBAR product is designed to help people ditch plastic without compromising experience.\n\nToday, HiBAR is transforming bathrooms everywhere—and we’d love for your store to be part of that movement. Your customers care about planet-friendly solutions. We make it easy (and gorgeous) for them to choose better.\n\nLet’s help your shoppers ditch the bottle, one bar at a time.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:18.434Z",
    importedBy: "entity-db-cli",
  },
};
